module.exports = __webpack_public_path__ + "img/AF.ab03c867.svg";